import React, { useState, useEffect, useRef } from "react";
import "./accountSetting.scss";

import UserImg from "../../../assets/images/providerProfileImg.png";
import {
  CallIcon,
  DeleteIcon,
  EditIcon,
  EmailIcon,
  LocationIcon,
  NotificationSettingIcon,
  PasswordIcon,
} from "../../../components/Icons";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OverAllRating from "../../../components/overAllRating/OverAllRating";
import Comments from "../../../components/comments/Comments";
import { useSelector, useDispatch } from "react-redux";
import { selectUser, loginr, logout } from "../../../slice/authSlice";
import axios from "axios";
import {
  updateProfile_customer,
  updateNotificationSettings,
  provider_getProfile,
  sendReferralEmail,
  fetchSavedAddress,
  addCard,
  fetchAuthorizeCustomerProfile,
  deleteCard,
  logOut,
  deleteProfileById,
  ChangePassword,
} from "../../../services/auth.service";
import { toast_success } from "../../../config/Constant";
import { apiUrl } from "../../../environment";
import { toast } from "react-toastify";

import StarRating from "../../../components/rating/StarRating";
import { Await, useNavigate } from "react-router-dom";
import { encryptData } from "../../../utils/encryptDecrypt";
import { clearUserLocation, setLoader } from "../../../slice/commonSlice";
import ConfirmModal from "../../../modals/confirmModal/ConfirmModal";
import * as cardValidator from "card-validator";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import RegisterSecond from "../../../modals/registerSecond/registerSecStep";
import authorizelogo from "../../../assets/images/Authorize.net_logo.png";
import DeleteModal from "../../../modals/deleteModel/DeleteModal";

import { Autocomplete } from "@react-google-maps/api";

const LocationInput = ({ editMode, input, setInput }) => {
  const autocompleteRef = useRef(null);

  const handlePlaceChanged = () => {
    if (autocompleteRef?.current) {
      const place = autocompleteRef?.current?.getPlace();
      if (!place?.geometry) {
        console.error("Place details not found");
        return;
      }

      const location = place?.formatted_address;
      setInput({ ...input, location });
    }
  };

  return (
    <Autocomplete
      onLoad={(ref) => (autocompleteRef.current = ref)}
      onPlaceChanged={handlePlaceChanged}
      options={{ componentRestrictions: { country: "BM" } }} // Restrict to Bermuda
    >
      <Form.Control
        type="text"
        placeholder="Location"
        disabled={!editMode}
        value={input.location}
        onChange={(e) => setInput({ ...input, location: e.target.value })}
      />
    </Autocomplete>
  );
};

const AccountSetting = () => {
  const API_URL = apiUrl;
  const [viewRating, setViewRating] = useState(false);

  // ************************************************************************************************************************

  const [editMode, setEditMode] = useState(false);
  const [editMode2, setEditMode2] = useState(false);
  const [editMode3, setEditMode3] = useState(false);

  const [providerData, setProviderData] = useState(null);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const [alignment, setAlignment] = useState(user.userType);

  const [notificationSettings, setNotificationSettings] = useState({});
  const [input, setInput] = useState({});
  const [referinput, setReferInput] = useState({});

  const [authorizeCustomerProfile, setAuthorizeCustomerProfile] = useState();
  const [cardNumber, setCardNumber] = useState("");
  // const [cardExpirationDate, setCardExpirationDate] = useState("");
  // const [cardName, setCardName] = useState("");
  const [cardMonth, setCardMonth] = useState("");
  const [cardYear, setCardYear] = useState("");
  const [cvv, setCvv] = useState();
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [confirmStatus, setConfirmStatus] = useState(false);
  const [confirmDeleteProfile, setConfirmDeleteProfile] = useState(false);
  const [image1, setImage1] = useState(null);
  const [errors, setErrors] = useState({
    cardNumber: "",
    cardYear: "",
    cardCvv: "",
  });
 const [currentPassword, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState();
   const [confirmNewPassword, setConfirmNewPassword] = useState();



  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear; i <= currentYear + 21; i++) {
    years.push(i);
  }
  const [openProviderRegSecModal, setOpenProvidrRegSecModal] = useState(false);

  const onFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setInput((prev) => ({
        ...prev,
        profilePic: file,
      }));

      const reader = new FileReader();
      reader.onload = (event) => {
        setImage1(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchUserProfile = async () => {
    try {
      const response = await provider_getProfile();

      setProviderData(response?.data?.provider?.ratingUser);

      const addressResponse = await fetchSavedAddress("sender"); // Update the payload as needed

      // ******************************************************************************************************

      setNotificationSettings({
        userNotificationJob: response.data.provider.userNotificationJob,
        userNotificationRating: response.data.provider.userNotificationRating,
        userNotificationChat: response.data.provider.userNotificationChat,
      });
      // ******************************************************************************************************
      console.log("response.data.provider.password",response.data.provider.password)
      setInput({
        email: response.data.provider.email || "",
        phone: response.data.provider.phone || "",
        location: response.data.provider.location || "",
        address: response.data.location || "",
        profilePic: response.data.provider.profilePic || UserImg,
        firstName: response.data.provider.firstName || "",
        lastName: response.data.provider.lastName || "",
      });
    } catch (error) {
      // Handle errors
      console.error("Error fetching user profile:", error);
    }
  };
  // **********************************************************************************************************
  useEffect(() => {
    fetchUserProfile();
  }, []); // The empty dependency array ensures that this effect runs only once on component mount

  // **********************************************************************************************************
  // ****************************************************************************************************************************
  const formData = new FormData();

  // Append each field to the FormData
  Object.entries(input).forEach(([key, value]) => {
    formData.append(key, value);
  });

  //get authorize customer profile
  const getAuthorizeCustomerProfile = async () => {
    let payload = {
      customerProfileId: user?.userCustomerProfileId,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchAuthorizeCustomerProfile(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setAuthorizeCustomerProfile(response?.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getAuthorizeCustomerProfile();
  }, []);

  const checkCard = () => {
    let valid = true;
    const cardNumberValidation = cardValidator.number(cardNumber);
    const expiryDateValidation = cardValidator.expirationDate({
      month: cardMonth,
      year: cardYear,
    });
    const cvvValidation = cardValidator.cvv(cvv);
    let newErros = { ...errors };
    if (!cardNumberValidation.isValid) {
      // alert('Invalid Card Number');
      valid = false;
      newErros.cardNumber = "Invalid card number";
      // return;
    } else {
      newErros.cardNumber = "";
    }

    if (!expiryDateValidation.isValid) {
      valid = false;
      newErros.cardYear = "Invalid card expiry date";
      // return;
    } else {
      newErros.cardYear = "";
    }

    if (!cvvValidation.isValid) {
      valid = false;
      newErros.cardCvv = "Invalid card number";
      // return;
    } else {
      newErros.cardCvv = "";
    }
    setErrors(newErros);
    return valid;
  };

  const handleCardNumber = (value) => {
    value = value.replace(/\s/g, ""); // Remove existing spaces
    value = value.replace(/-/g, ""); // Remove existing dashes

    // Add space or dash after every four digits
    value = value.replace(/(\d{4})(?=\d)/g, "$1 ");

    // Trim extra characters if the length exceeds 19 digits (including spaces)
    value = value.slice(0, 23);
    setCardNumber(value);
  };

  const handleAddCard = async () => {
    if (checkCard()) {
      const payload = {
        // cardName,
        cardExpirationDate: encryptData(cardMonth + cardYear),
        cvv: encryptData(cvv),
        customerProfileId: user.userCustomerProfileId,
        cardNumber: encryptData(cardNumber.replace(/\s/g, "")),
      };
      await dispatch(setLoader(true));
      try {
        const response = await addCard(payload);
        await dispatch(setLoader(false));
        setCardMonth("");
        setCardNumber("");
        setCardYear("");
        // setCardName("");
        setSelectedCardId(null);
        setCvv("");
        getAuthorizeCustomerProfile();
        if (response?.data?.status) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        await dispatch(setLoader(false));
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleDelete = (id) => {
    setSelectedCardId(id);
    setConfirmStatus(true);
  };

  const handelDeleteProfile = async () => {
    const deletePayload = {
      userId: user.id, // Ensure user.id exists
    };

    const logOutPayload = {
      deviceId: "deedid", // Replace with the actual deviceId dynamically if needed
    };

    try {
      // Show loader
      dispatch(setLoader(true));

      // Step 1: Attempt to Delete the User Profile
      const deleteResponse = await deleteProfileById(deletePayload);

      // Check if the deletion was successful
      if (deleteResponse?.status === 200) {
        // Step 2: Log Out the User
        const logOutResponse = await logOut(logOutPayload);

        // Clear local storage and Redux state
        localStorage.removeItem("accessToken");
        dispatch(clearUserLocation());
        dispatch(logout());

        // Step 3: Redirect and Show Success Notification
        setConfirmDeleteProfile(false);
        navigate("/?registerModal=true");
        toast.success(
          deleteResponse.data.message || "Profile deleted successfully!",
          toast_success
        );
      } else {
        console.error("Failed to delete profile:", deleteResponse.data.message);
        toast.error(deleteResponse.data.message || "Failed to delete profile.");
      }
    } catch (error) {
      console.error("Error in handelDeleteProfile:", error);

      // Show a user-friendly error message
      toast.error(
        error.response?.data?.message ||
          "An unexpected error occurred. Please try again."
      );
    } finally {
      // Hide loader regardless of outcome
      dispatch(setLoader(false));
    }
  };

  const handleConfirm = (status) => {
    if (status) {
      handleDeleteCard();
    }
    setConfirmStatus(false);
  };

  const handleDeleteCard = async () => {
    const payload = {
      customerProfileId: user.userCustomerProfileId,
      paymentProfileId: selectedCardId,
    };
    await dispatch(setLoader(true));
    try {
      const response = await deleteCard(payload);
      await dispatch(setLoader(false));
      if (response?.data?.status) {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        toast.error(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      getAuthorizeCustomerProfile();
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleUpdateProfile = async () => {
  console.log("formData===>",formData)
    // return
    try {
      // Call the updateProfile_customer function with the updated user data
      const response = await updateProfile_customer(formData);
      // Handle the response as needed
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      setInput({
        password: "",
      });
      fetchUserProfile();
    } catch (error) {
      // Handle errors
      console.error("Error updating profile:", error);
    }
  };

  const sendReferralEmailFunction = async () => {
    await dispatch(setLoader(true));
    try {
      // Call the updateProfile_customer function with the updated user data
      const response = await sendReferralEmail(referinput);
      // Handle the response as needed
      await dispatch(setLoader(false));
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      setReferInput({
        email: "",
      });
    } catch (error) {
      // Handle errors
      await dispatch(setLoader(false));
      console.error("Error updating profile:", error);
    }
  };

  const toggleEditModeProfile = (mode) => {
    if (mode === false || mode === "false") {
      // If in edit mode, update the data
      handleUpdateProfile();
    }
    setEditMode(mode);
  };

  const toggleEditModeAddress = (mode) => {
    if (mode === false || mode === "false") {
      // If in edit mode, update the data

      handleUpdateProfile();
    }
    setEditMode2(mode);
  };



const handleUpdatePassword = async () => {
  if (!currentPassword || !newPassword || !confirmNewPassword) {
    return toast.error("All fields are required.");
  }

  if (newPassword !== confirmNewPassword) {
    return toast.error("New passwords do not match.");
  }

  const payload = {
    currentPassword,
    newPassword,
    confirmNewPassword,
  };

  try {
    const response = await ChangePassword(payload);
    toast.success("Password updated successfully.");
  } catch (error) {
    console.error("Password update failed:", error);
    toast.error(
      error?.response?.data?.message || "Failed to update password."
    );
  }
};


  const toggleEditModepassword = (mode) => {
    if (mode === false || mode === "false") {
      // If in edit mode, update the data

      handleUpdatePassword();
    }
    setEditMode3(mode);
  };

  // ****************************************notification settings********************************************************************************

  // Function to handle notification setting changes
  const handleNotificationSettingChange = async (setting) => {
    try {
      const updatedSettings = {
        ...notificationSettings,
        // [setting]: notificationSettings[setting] === "true" ? "false" : "true",
        [setting]: !notificationSettings[setting],
      };

      const response = await updateNotificationSettings(updatedSettings);

      if (response.data.status == true) {
        // setNotificationSettings(updatedSettings);
        setNotificationSettings((prevSettings) => ({
          ...prevSettings,
          [setting]: !prevSettings[setting],
        }));

        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        console.error("Failed to update notification setting");
      }
    } catch (error) {
      // Handle errors
      console.error("Error updating notification setting:", error);
    }
  };

  // *********************************************************************************************************************************
  const handleAlignment = async (event, newAlignment) => {
    const paylaod = {
      deviceId: "deedid",
    };

    localStorage.setItem("accessToken", "");
    const result = await logOut(paylaod);
    dispatch(clearUserLocation());
    dispatch(logout());
    // setShow(false);

    navigate("/?registerModal=true");
  };
  return (
    <>
      {openProviderRegSecModal ? (
        <RegisterSecond
          setOpenProvidrRegSecModal={setOpenProvidrRegSecModal}
          openProviderRegSecModal={openProviderRegSecModal}
        />
      ) : null}
      <div className="account-setting-wrap">
        <div className="box-wrapper">
          {viewRating ? (
            <>
              <div className="account-wrapper">
                <div className="account-info-wrap">
                  <div className="user-account-detail-top">
                    <div className="user-img-wrap">
                      <div className="user-pic">
                        <img src={image1 || input.profilePic} alt="user" />
                      </div>
                      <div className="edit-pic">
                        <input type="file" onChange={onFileChange} />
                        <EditIcon />
                      </div>
                    </div>

                    <div className="user-name-wrap">
                      <div className="username">
                        {input.firstName} {input.lastName}
                      </div>
                      <div className="user-rating-wrap">
                        <div className="user-rating-wrap">
                          <div className="rating"></div>
                          <div className="view-rating">
                            ({providerData}) -{" "}
                            <span
                              onClick={() => navigate("/consumer/viewrating")}
                            >
                              View Ratings
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div></div>
                  </div>
                </div>
                <div className="account-info-wrap">
                  <OverAllRating />
                </div>
                <div className="account-info-wrap">
                  <div className="account-info-title">All Reviews</div>
                  <Comments />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="account-wrapper">
                <div
                  className="account-info-wrap"
                  id="account-setting" /* ref={accountSettingRef} */
                >
                  <ToggleButtonGroup
                    value={alignment}
                    exclusive
                    onChange={handleAlignment}
                    aria-label="text alignment"
                  >
                    <ToggleButton value="provider" aria-label="left aligned">
                      Provider
                    </ToggleButton>
                    <ToggleButton value="user" aria-label="centered">
                      User
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <div className="account-info-title">Account setting</div>
                  <div className="user-account-detail-top">
                    <div className="user-img-wrap">
                      <div className="user-pic">
                        <img src={image1 || input.profilePic} alt="User" />
                      </div>
                      <div className="edit-pic">
                        <input type="file" onChange={onFileChange} />
                        <EditIcon />
                      </div>
                    </div>
                    <div className="user-name-wrap">
                      <div className="username">
                        {input.firstName} {input.lastName}
                      </div>
                      <div className="user-rating-wrap">
                        <div className="user-rating-wrap">
                          <div className="rating">
                            {providerData !== null && (
                              <StarRating rating={providerData} />
                            )}
                          </div>
                          <div className="view-rating">
                            ({providerData}) -{" "}
                            <span
                              onClick={() => navigate("/consumer/viewrating")}
                            >
                              View Ratings
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="edit-btn-wrap">
                      <Button
                        variant="outline-primary"
                        onClick={() => {
                          toggleEditModeProfile(!editMode);
                          // Call your updateData function here
                        }}
                      >
                        <i>
                          <EditIcon />
                        </i>{" "}
                        {editMode ? "Update" : "Edit"} <span>Profile</span>
                      </Button>
                    </div>
                    <div className="delete-btn-wrap bg-seconday text-white">
                      <Button
                        variant="outline-primary"
                        onClick={() => {
                          setConfirmDeleteProfile(true);
                        }}
                      >
                        <i>
                          <DeleteIcon />
                        </i>{" "}
                        <span>Delete Profile</span>
                      </Button>
                    </div>
                  </div>
                  <Form className="">
                    <Row className="mt-3">
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <EmailIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="email">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Email address"
                              disabled={true}
                              value={input.email}
                              onChange={(e) =>
                                setInput({ ...input, email: e.target.value })
                              }
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <CallIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="phone">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone Number"
                              disabled={!editMode}
                              value={input.phone}
                              onChange={(e) =>
                                setInput({ ...input, phone: e.target.value })
                              }
                            />
                          </Form.Group>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
                <div
                  className="account-info-wrap"
                  id="manage-address" /* ref={manageAddressRef} */
                >
                  <div className="account-info-title">
                    Manage Address
                    <div className="edit-btn-wrap">
                      <Button
                        variant="outline-primary"
                        onClick={() => {
                          toggleEditModeAddress(!editMode2);
                          // Call your updateData function here
                        }}
                      >
                        <i>
                          <EditIcon />
                        </i>{" "}
                        {editMode2 ? "Update" : "Edit"} <span>Address</span>
                      </Button>
                    </div>
                  </div>

                  <Row>
                    <Col md={12}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <LocationIcon />
                        </div>
                        <Form.Group className="mb-2" controlId="location">
                          <Form.Label>Location</Form.Label>
                          <LocationInput
                            editMode={editMode2}
                            input={input}
                            setInput={setInput}
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div
                  className="account-info-wrap"
                  id="password" /* ref={passwordRef} */
                >
                  <div className="account-info-title">
                    Password
                    <div className="edit-btn-wrap">
                      <Button
                        variant="outline-primary"
                        onClick={() => {
                          toggleEditModepassword(!editMode3);
                          // Call your updateData function here
                        }}
                      >
                        <i>
                          <EditIcon />
                        </i>{" "}
                        {editMode3 ? "Update" : "Edit"} <span>Password</span>
                      </Button>
                    </div>
                  </div>

                  <Row>
                    <Col md={12}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <PasswordIcon />
                        </div>
                        <Form.Group className="mb-2" controlId="password">
                          <Form.Label>Passowrd</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Password"
                            disabled={true}
                            value={input.password}
                            onChange={(e) =>
                              setInput({ ...input, password: e.target.value })
                            }
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                  {editMode3 &&(
                    <>
                    <Row>
                    <Col md={12}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <PasswordIcon />
                        </div>
                        <Form.Group className="mb-2" controlId="password">
                          <Form.Label>Old Passowrd</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Password"
                            disabled={!editMode3}
                            value={currentPassword}
                            onChange={(e) =>
                              setCurrentPassword( e.target.value )
                            }
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <PasswordIcon />
                        </div>
                        <Form.Group className="mb-2" controlId="password">
                          <Form.Label>New Passowrd</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Password"
                            disabled={!editMode3}
                            value={newPassword}
                            onChange={(e) =>
                             setNewPassword( e.target.value )
                            }
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <PasswordIcon />
                        </div>
                        <Form.Group className="mb-2" controlId="password">
                          <Form.Label>Confirm Passowrd</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Password"
                            disabled={!editMode3}
                            value={confirmNewPassword}
                            onChange={(e) =>
                              setConfirmNewPassword( e.target.value )
                            }
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                    
                    </>
                  )}
                </div>
                <div className="account-info-wrap" id="manage-payment">
                  <div className="account-info-title">
                    Manage your payment methods
                  </div>
                  <div className="payment-method-wrapper">
                    {authorizeCustomerProfile?.customerProfile?.profile?.paymentProfiles?.map(
                      (card, index) => (
                        <>
                          <div className="card-wrapper primary" key={index}>
                            <label htmlFor={`primary-${index}`}>
                              <div className="card-left">
                                <input
                                  className="radioInput"
                                  type="radio"
                                  name="primary"
                                  id={`primary-${index}`}
                                  checked={
                                    selectedCardId ===
                                    card.customerPaymentProfileId
                                  }
                                  onChange={() =>
                                    setSelectedCardId(
                                      card.customerPaymentProfileId
                                    )
                                  }
                                />
                              </div>
                              <div className="card-right">
                                <div className="card-number">
                                  XXXX XXXX{" "}
                                  {card?.payment?.creditCard?.cardNumber}
                                </div>

                                <div className="card-logo ">
                                  {card?.payment?.creditCard?.cardType}
                                  {/* <MasterCardIcon /> */}
                                </div>
                              </div>
                            </label>
                          </div>
                          <div className="add-new-card-row">
                            <div className="add-new-card"></div>
                            <div className="manage-card-wrap">
                              <div
                                className="manage-card"
                                onClick={() =>
                                  handleDelete(card.customerPaymentProfileId)
                                }
                              >
                                <DeleteIcon /> <span>Delete</span>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    )}

                    <div className="add-new-card-form">
                      <div className="add-new-title">🔒Secure Payment</div>

                      <div className="add-new-title">Add New Card</div>
                      <div className="add-new-card w-100">
                        <Row className="g-3">
                          <Col md={12}>
                            <Form.Label>Card Number</Form.Label>
                            <Form.Control
                              type="text"
                              value={cardNumber}
                              placeholder="Enter Card Number"
                              onChange={(e) => handleCardNumber(e.target.value)}
                            />
                            <div className="payment-error">
                              {errors?.cardNumber ? errors.cardNumber : null}
                            </div>
                          </Col>
                          <Col md={4}>
                            <Form.Label>Expiry Month</Form.Label>
                            <Form.Select
                              aria-label="Default select example"
                              value={cardMonth}
                              onChange={(e) => setCardMonth(e.target.value)}
                            >
                              <option>Select Month</option>
                              <option value="01">01</option>
                              <option value="02">02</option>
                              <option value="03">03</option>
                              <option value="04">04</option>
                              <option value="05">05</option>
                              <option value="06">06</option>
                              <option value="07">07</option>
                              <option value="08">08</option>
                              <option value="09">09</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </Form.Select>
                          </Col>

                          <Col md={4}>
                            <Form.Label>Expiry Year</Form.Label>
                            <Form.Select
                              value={cardYear}
                              onChange={(e) => setCardYear(e.target.value)}
                              aria-label="Select Expiry Year"
                            >
                              <option value="">Select Year</option>
                              {years.map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </Form.Select>
                            <div className="payment-error">
                              {errors?.cardYear ? errors.cardYear : null}
                            </div>
                          </Col>
                          <Col md={4}>
                            <Form.Label>CVV</Form.Label>
                            <Form.Control
                              type="text"
                              value={cvv}
                              placeholder="Enter CVV"
                              onChange={(e) => setCvv(e.target.value)}
                            />
                          </Col>
                          <div className="payment-error">
                            {errors?.cardCvv ? errors.cardCvv : null}
                          </div>
                        </Row>
                        <div className="d-flex justify-content-between mt-3 align-items-center">
                          <Button variant="primary" onClick={handleAddCard}>
                            Add Card
                          </Button>
                        </div>
                        <div className="secured-payment d-flex justify-content-end align-items-center">
                          <span style={{ fontSize: "14px" }}>Powered By :</span>
                        </div>
                        <div className="secured-payment d-flex justify-content-end align-items-center">
                          <img
                            src={authorizelogo}
                            alt="Authorize Logo"
                            style={{ width: "100px", height: "auto" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="account-info-wrap" id="refer-friend">
                  <div className="account-info-title">Refer a friend</div>
                  <div className="refer-wrapper">
                    <div className="refer-input-wrap">
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <EmailIcon />
                        </div>
                        <Form.Group controlId="email">
                          <Form.Control
                            type="email"
                            placeholder="Email address"
                            value={referinput.email}
                            onChange={(e) =>
                              setReferInput({
                                ...referinput,
                                email: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <div className="refer-btn-wrap">
                      <Button
                        variant="outline-primary"
                        onClick={sendReferralEmailFunction}
                      >
                        Send Refer Link
                      </Button>
                    </div>
                  </div>
                </div>

                {/* ******************************** Notifications Setting***********************************************************************************                */}
                <div className="account-info-wrap" id="notifications">
                  <div className="account-info-title">
                    Notifications Setting
                  </div>

                  <div className="notification-setting-wrapper">
                    <div className="notification-setting-row">
                      <div className="notification-setting-left">
                        <div className="icon-wrap">
                          <NotificationSettingIcon />
                        </div>
                        <div className="notification-setting-title">
                          {/*   Received Request Notification */}
                          User Notification Job
                        </div>
                      </div>
                      <div className="notification-setting-right">
                        <Form.Check
                          type="switch"
                          id="receivedRequestSwitch"
                          checked={notificationSettings.userNotificationJob}
                          onChange={() =>
                            handleNotificationSettingChange(
                              "userNotificationJob"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="notification-setting-row">
                      <div className="notification-setting-left">
                        <div className="icon-wrap">
                          <NotificationSettingIcon />
                        </div>
                        <div className="notification-setting-title">
                          {/* Message Notification */}
                          User Notification Rating
                        </div>
                      </div>
                      <div className="notification-setting-right">
                        <Form.Check
                          type="switch"
                          id="messageSwitch"
                          checked={notificationSettings.userNotificationRating}
                          onChange={() =>
                            handleNotificationSettingChange(
                              "userNotificationRating"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="notification-setting-row">
                      <div className="notification-setting-left">
                        <div className="icon-wrap">
                          <NotificationSettingIcon />
                        </div>
                        <div className="notification-setting-title">
                          {/*  Remider Notification */}
                          User Notification Chat
                        </div>
                      </div>
                      <div className="notification-setting-right">
                        <Form.Check
                          type="switch"
                          id="reminderSwitch"
                          checked={notificationSettings.userNotificationChat}
                          onChange={() =>
                            handleNotificationSettingChange(
                              "userNotificationChat"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {confirmStatus ? (
        <ConfirmModal
          isConfirm={confirmStatus}
          text="Are you sure you want to remove this payment method?"
          handleClose={handleConfirm}
        />
      ) : null}
      {confirmDeleteProfile ? (
        <DeleteModal
          isConfirm={handelDeleteProfile}
          text="Are you sure you want to delete your profile? This action cannot be undone, and all associated data will be permanently removed."
          handleClose={setConfirmDeleteProfile}
        />
      ) : null}
    </>
  );
};

export default AccountSetting;